<template>
    <div>
        <!-- 标题 -->
        <div class="web-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/network/webMonitor">{{$t('alarms.network.AppService.title')}}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.monitoringSummary') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <!-- 查询框 -->
        <div class="web-top">
            <Row :gutter="16">
                <Col span="12">
                    <Select v-model="timeType" @on-change="changeTimeTypeAzure(timeType)">
                        <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <!-- 折线图 -->
        <Row :gutter="16">
            <Col span="12" v-for="(item,index) in list" :key="index">
                <Card :padding="8">
                    <p slot="title">{{item.title}}</p>
                    <a href="#" slot="extra" @click.prevent="changeFull(item)">
                        <Icon type="ios-expand" size="18"/>
                    </a>
                    <div :id="item.id" :ref="item.id" style="width:100%;height: 240px;"></div>
                </Card>
            </Col>
        </Row>
        <!-- 放大弹出框 -->
        <Modal v-model="isShowModal" :mask-closable="false" :closable="false" width="65%">
            <Row>
                <Col span="24">
                    <h3>{{lineTitle}}</h3>
                    <div id="chart-part" ref="fullChart" style="width:100%; height:420px;"></div>
                </Col>
            </Row>
            <div slot="footer">
                <div>
                    <Button @click="cancel">{{$t('alarms.common.close')}}</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../../../../utils/cookieUtil.js'
    export default {
        name: 'WEB',
        data () {
            return {
                // 放大功能
                lineTitle:'',
                isShowModal: false,
                //折线图
                list: [{
                    id: 'cpuTime',
                    title:this.$t('alarms.network.AppService.line.CPUTimeseconds')
                },
                {
                    id: 'memoryWorkingSet',
                    title:this.$t('alarms.network.AppService.line.MemorySetbytes')
                },{
                    id: 'averageResponseTime',
                    title:this.$t('alarms.network.AppService.line.ResponseTimeseconds')
                }],
                timeType:0,
                timeList:[],
                id:'',
                accountId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                // echarts实例
                chartCpuTime:'',
                chartAverageResponseTime:'',
                chartMemoryWorkingSet:'',
                cpuTimeOption:{},
                memoryWorkingSetOption:{},
                averageResponseTimeOption:{},
                //Azure数组
                azureAppServiceCpuTime:[],
                azureAppServiceMemoryWorkingSet:[],
                azureAppServiceAverageResponseTime:[],
                xaxisData:[]
            }
        },
        mounted: function(){
            this.queryTimeHorizon();
            // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartCpuTime.resize();
                self.chartMemoryWorkingSet.resize();
                self.chartAverageResponseTime.resize();
            });
        },
        methods: {
            /******************放大********************************/
            changeFull:function(item){
                this.isShowModal=true;
                this.lineTitle=item.title;
                this.$nextTick(() => {
                    const chartFul = this.$refs.fullChart;
                    if(chartFul){
                        const fullChart = this.$echarts.init(
                            document.getElementById("chart-part")
                        );
                        fullChart.clear();
                        if(item.id=='cpuTime'){
                            var optionFll = this.cpuTimeOption;
                        }else if(item.id=='memoryWorkingSet'){
                            var optionFll = this.memoryWorkingSetOption;
                        }else if(item.id=='averageResponseTime'){
                            var optionFll = this.averageResponseTimeOption;
                        }
                        
                        fullChart.setOption(optionFll);
                        window.addEventListener("resize", function() {
                            fullChart.resize();
                        });    
                    }
                });
            },
            // 模态框取消事件
            cancel() {
                this.isShowModal = false;
            },
            /******************查询********************************/
            // 查询时间范围
            queryTimeHorizon: function(){
                this.$api.cloudWatch.queryTimeHorizon("userName",getCookie(global.cookieName))
                .then(res => {
                    this.timeList = res.data;
                    this.checkAzureAppService();
                })
            },
            // Azure折线图
            checkAzureAppService: function(){
                this.$api.cloudWatch.checkAzureAppService({
                    "accountId":this.$route.query.accountId,
                    "timeHorizon":this.timeType,
                    "appServiceName":this.$route.query.name
                })
                .then(res => {
                    // Azure
                    this.xaxisData=res.data.azureTimeline;
                    this.azureAppServiceCpuTime=res.data.azureAppServiceCpuTime;
                    this.azureAppServiceMemoryWorkingSet=res.data.azureAppServiceMemoryWorkingSet;
                    this.azureAppServiceAverageResponseTime=res.data.azureAppServiceAverageResponseTime;
                    this.allAzure();
                })
            },
            changeTimeTypeAzure:function(){
                this.checkAzureAppService();
            },
            /******************所有折线图********************************/
            allAzure:function(){
                this.cpuTimeLine();
                this.memoryWorkingSetLine();
                this.averageResponseTimeLine();
            },
            /*************Azure折线图*****************************/
            // CPU Time（秒）
            cpuTimeLine:function(){
                this.chartCpuTime=this.$echarts.init(document.getElementById("cpuTime"));
                this.cpuTimeOption={
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // CPU Time
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:['CPU Time']
                    },
                    series: [{
                        name:'CPU Time',
                        type:'line',
                        data:this.azureAppServiceCpuTime,
                        itemStyle: {
                            normal: {
                                color: "#91c7ae",
                                lineStyle: {
                                    color: "#91c7ae"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartCpuTime.setOption(this.cpuTimeOption)
            },
             // 内存集（字节）
            memoryWorkingSetLine:function(){
                this.chartMemoryWorkingSet=this.$echarts.init(document.getElementById("memoryWorkingSet"));
                this.memoryWorkingSetOption={
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 内存集
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('alarms.network.AppService.line.MemorySet')]
                    },
                    series: [{
                        name:this.$t('alarms.network.AppService.line.MemorySet'),
                        type:'line',
                        data:this.azureAppServiceMemoryWorkingSet,
                        itemStyle: {
                            normal: {
                                color: "#ceca58",
                                lineStyle: {
                                    color: "#ceca58"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartMemoryWorkingSet.setOption(this.memoryWorkingSetOption)
            },
             // 响应时间（秒）
            averageResponseTimeLine:function(){
                this.chartAverageResponseTime=this.$echarts.init(document.getElementById("averageResponseTime"));
                this.averageResponseTimeOption={
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 响应时间
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('alarms.network.AppService.line.ResponseTime')]
                    },
                    series: [{
                        name:this.$t('alarms.network.AppService.line.ResponseTime'),
                        type:'line',
                        data:this.azureAppServiceAverageResponseTime,
                        itemStyle: {
                            normal: {
                                color: "#803500",
                                lineStyle: {
                                    color: "#803500"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartAverageResponseTime.setOption(this.averageResponseTimeOption)
            },
            /********************************/
            // 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/network/webDetail/',query: {id: this.id,accountId:this.accountId,region:this.region,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .web-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-col-span-12
    {
        margin-bottom: 20px;
    }
    .web-top
    {
        width: 100%;
        height: 53px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/web/web_dashboard/WEB.vue